module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAABRklEQVR4AWOgC/h/5EhU9d4jF57/Dw8Hko5pm4EiDMYzGQwnKZmEceqWAtlQBAFA1UAVcA1ANlAPRIWERqiupiOjfi+Khv/////9+xdIAjX8hwEWgw6zwBYenUJrLRMRgzx11wZGw0lQDUB1UCQnB2czGE1TsOg0MJsYE5KprjeLT7uG0WQGVAPE0QgnrVjR27+X3bhLx67YxLY6OjJSw7hWXsXTIjINZsP06X6FO+Aaqrv2A/ULm9f7hCQ4RIaFlAtHl+dFJ1UzCJpANQB9g4ksffO9vHxyenpaVxs4ZTTLa7mzC+vj0+DiExblbZedl5a1fGZw4dTIhCoZvVB8GoTVw9ytDfUNLBWjnZIbGtPTS6UNU/FpYNZt64mRdHKzlzOO1LH06UkU49EsxKeBwWiqn5WppEEKkM2m3xhubcik38kwKAEAksO2uiqi7ncAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/GS.png
// module id = 1154
// module chunks = 0